/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { PaymentMethod } from './PaymentMethod';
// @ts-ignore
import {
// @ts-ignore
    PaymentMethodFromJSON,
// @ts-ignore
    PaymentMethodFromJSONTyped,
// @ts-ignore
    PaymentMethodToJSON,
} from './PaymentMethod';

/**
 * 
 * @export
 * @interface PaymentMethodListResponse
 */
export interface PaymentMethodListResponse {
    /**
     * 
     * @type {number}
     * @memberof PaymentMethodListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethodListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<PaymentMethod>}
     * @memberof PaymentMethodListResponse
     */
    items: Array<PaymentMethod>;
}

/**
 * Check if a given object implements the PaymentMethodListResponse interface.
 */
// @ts-ignore
export function instanceOfPaymentMethodListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function PaymentMethodListResponseFromJSON(json: any): PaymentMethodListResponse {
    return PaymentMethodListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function PaymentMethodListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(PaymentMethodFromJSON)),
    };
}

// @ts-ignore
export function PaymentMethodListResponseToJSON(value?: PaymentMethodListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(PaymentMethodToJSON)),
    };
}

